import { configSelector } from '../../../redux/ConfigState/ConfigState.selectors';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { useRecurly } from '@recurly/react-recurly';
import { useEffect } from 'react';
import { PaymentMethodsCommandNames, StatusTypes, VendorType } from '@chegg/commerce-utils';
import { doFireStatusUpdate } from '../../../utils/CallbackUtils';
import { Component } from '../../../constants/CallbackConstants';
import { sendNewRelicMessage } from '../../../utils/NewRelicUtils';
import { useDispatch } from 'react-redux';
import { createMOPError } from '../../../redux/PaymentState/PaymentState.actions';
import { mopGeneric } from '../../../constants/PaymentTypes';
import { ERRORS } from '../../../constants/Errors';
import { MERCHANT_COUNTRY } from '../../../constants/AppConstants';
import { useHandlePaymentAuthorized } from './recurlyServiceHelpers';
export var useGooglePay = function useGooglePay() {
  var googePayButtonContainerId = 'google-pay-button-container';
  var _useAppSelector = useAppSelector(configSelector),
    appConstants = _useAppSelector.appConstants,
    country = _useAppSelector.country,
    priceSummary = _useAppSelector.priceSummary,
    _useAppSelector$isPri = _useAppSelector.isPrimary,
    isPrimary = _useAppSelector$isPri === void 0 ? true : _useAppSelector$isPri;
  var googlePayConstants = appConstants.googlePay;
  var merchantId = googlePayConstants.merchantId;
  var recurly = useRecurly();
  var dispatch = useDispatch();
  var handlePaymentAuthorized = useHandlePaymentAuthorized();
  useEffect(function () {
    var googlePay = recurly.GooglePay({
      currency: priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.currency,
      country: MERCHANT_COUNTRY,
      total: "".concat(priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.total),
      googleMerchantId: merchantId,
      billingAddressRequired: true,
      buttonOptions: {
        buttonColor: 'default',
        buttonType: 'plain',
        buttonSizeMode: 'fill'
      }
    });
    var handleGooglePayError = function handleGooglePayError(error) {
      if (error.code !== 'google-pay-not-supported' && error.statusCode !== 'CANCELED') {
        sendNewRelicMessage('Recurly Google Pay Service error', {
          errors: "".concat(JSON.stringify(error)),
          vendorType: VendorType.RECURLY
        });
        dispatch(createMOPError({
          message: {
            text: mopGeneric.message_detail,
            type: StatusTypes.ERROR,
            code: mopGeneric.message_id
          }
        }));
        doFireStatusUpdate([{
          status: StatusTypes.ERROR,
          command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
          payload: {
            component: Component.RECURLY_SERVICE,
            errors: [ERRORS.PAYMENT_PROCESSING_ERROR]
          }
        }]);
      }
    };
    googlePay.on('token', function (_ref) {
      var id = _ref.id;
      void handlePaymentAuthorized(id, isPrimary, country);
    });
    googlePay.on('ready', function (googlePayButton) {
      var _document$getElementB;
      (_document$getElementB = document.getElementById(googePayButtonContainerId)) === null || _document$getElementB === void 0 || _document$getElementB.appendChild(googlePayButton);
    });
    googlePay.on('error', handleGooglePayError);
    return function () {
      googlePay.off();
    };
  }, []);
  return googePayButtonContainerId;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/business/processors/recurly/GooglePayService.js
// module id = 4632
// module chunks = 11